import React, {useState} from "react";
export default (props) => {
	const [input1, onChangeInput1] = useState('');
	const [input2, onChangeInput2] = useState('');
	const [input3, onChangeInput3] = useState('');
	return (
		<div 
			style={{
				display: "flex",
				flexDirection: "column",
				background: "#FFFFFF",
			}}>
			<div 
				style={{
					height: 2768,
					alignSelf: "stretch",
					background: "#F6F7F9",
				}}>
				<div 
					style={{
						alignSelf: "stretch",
						display: "flex",
						flexDirection: "column",
						alignItems: "flex-start",
						paddingBottom: 111,
					}}>
					<div 
						style={{
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-start",
							position: "relative",
						}}>
						{/* <div 
							style={{
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								background: "#FFFFFF",
								paddingTop: 32,
								paddingBottom: 249,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/cgn9mb9y_expires_30_days.png"} 
								style={{
									width: 80,
									height: 80,
									marginBottom: 16,
									marginLeft: 32,
									objectFit: "fill",
								}}
							/>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 14,
									marginLeft: 32,
									marginRight: 32,
									gap: 12,
								}}>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 18,
										fontWeight: "bold",
									}} >
									{"Guy Hawkins"}
								</span>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderRadius: 3,
										paddingTop: 1,
										paddingBottom: 1,
										paddingLeft: 6,
										paddingRight: 6,
									}}>
									<span 
										style={{
											color: "#FFFFFF",
											fontSize: 10,
											fontWeight: "bold",
										}} >
										{"Mentee"}
									</span>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									paddingRight: 2,
									marginBottom: 64,
									marginLeft: 32,
									marginRight: 32,
									gap: 6,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/2i3bu3w3_expires_30_days.png"} 
									style={{
										width: 15,
										height: 15,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 12,
									}} >
									{"yourguy123@email.com"}
								</span>
							</div>
							<span 
								style={{
									color: "#979797",
									fontSize: 12,
									fontWeight: "bold",
									marginBottom: 32,
									marginLeft: 32,
								}} >
								{"MAIN MENU"}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/lm7iiy2g_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Dashboard"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 4,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/29q0o80w_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Requests"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 30,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/d3n59wv7_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"My Goals"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
									borderRadius: 8,
									paddingTop: 10,
									paddingBottom: 10,
									paddingLeft: 12,
									paddingRight: 90,
									marginBottom: 30,
									marginLeft: 20,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/2n4jggrv_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<input
									placeholder={"Chats"}
									value={input1}
									onChange={(event)=>onChangeInput1(event.target.value)}
									style={{
										color: "#6C6C6C",
										fontSize: 16,
										width: 42,
										background: "none",
										border: "none",
										paddingTop: 2,
										paddingBottom: 2,
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/z1tj6c0s_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Curriculum"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/2nthgle1_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Lessons"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 32,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/dv6d3yx5_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Resources"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingTop: 8,
									paddingBottom: 8,
									paddingLeft: 8,
									paddingRight: 11,
									marginBottom: 32,
									marginLeft: 24,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/mpjo2iij_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Mentors"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/8ddzu4pk_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Progress"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/n23quy24_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Community"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/fsh2v0ie_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Bookmarks"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/h5p095y2_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Downloads"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									marginRight: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/evcy2km5_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Notifications"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/gszxex2d_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Settings"}
								</span>
							</div>
						</div> */}
						<div 
							style={{
								position: "absolute",
								top: 211,
								left: 0,
								width: 236,
								height: 1,
								background: "#E6E6E6",
							}}>
						</div>
						<div 
							style={{
								position: "absolute",
								bottom: 0,
								left: 227,
								width: 1213,
								display: "flex",
								alignItems: "flex-start",
								background: "#FFFFFF",
								paddingTop: 20,
								paddingBottom: 20,
								paddingLeft: 40,
								paddingRight: 40,
								boxShadow: "0px -2px 4px #00000000",
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									flex: 1,
								}} >
								{"© 2025 Global Impact Innovators. All Rights Reserved."}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									marginRight: 27,
								}} >
								{"Privacy"}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									marginRight: 26,
								}} >
								{"Terms of Service"}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
								}} >
								{"Help & FAQ"}
							</span>
						</div>
					</div>
					<div 
						style={{
							display: "flex",
							alignItems: "center",
							background: "#FFFFFF",
							paddingTop: 20,
							paddingBottom: 20,
							paddingLeft: 33,
							paddingRight: 33,
							marginBottom: 32,
							marginLeft: 234,
						}}>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								alignItems: "center",
								background: "#F6F7F9",
								borderRadius: 8,
								paddingTop: 14,
								paddingBottom: 14,
								paddingLeft: 20,
								paddingRight: 20,
								marginRight: 257,
								gap: 12,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/v62g9uxq_expires_30_days.png"} 
								style={{
									width: 21,
									height: 21,
									objectFit: "fill",
								}}
							/>
							<input
								placeholder={"For quick access to courses, mentors, or posts"}
								value={input2}
								onChange={(event)=>onChangeInput2(event.target.value)}
								style={{
									color: "#6C6C6C",
									fontSize: 14,
									width: 306,
									background: "none",
									border: "none",
									paddingTop: 2,
									paddingBottom: 2,
								}}
							/>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								alignItems: "center",
								background: "#FEF0E9",
								borderRadius: 8,
								paddingTop: 10,
								paddingBottom: 10,
								paddingLeft: 20,
								paddingRight: 23,
								marginRight: 32,
								gap: 8,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/wn58pp7v_expires_30_days.png"} 
								style={{
									width: 32,
									height: 32,
									objectFit: "fill",
								}}
							/>
							<span 
								style={{
									color: "#F57E47",
									fontSize: 17,
									fontWeight: "bold",
								}} >
								{"Ask Giia"}
							</span>
						</div>
						<div 
							style={{
								width: 1,
								height: 58,
								background: "#E6E6E6",
								marginRight: 31,
							}}>
						</div>
						<img
							src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/tm7q8f6q_expires_30_days.png"} 
							style={{
								width: 24,
								height: 24,
								marginRight: 24,
								objectFit: "fill",
							}}
						/>
						<img
							src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/5ltypeyc_expires_30_days.png"} 
							style={{
								width: 24,
								height: 24,
								objectFit: "fill",
							}}
						/>
					</div>
					<span 
						style={{
							color: "#010101",
							fontSize: 40,
							fontWeight: "bold",
							marginBottom: 32,
							marginLeft: 267,
						}} >
						{"Chats"}
					</span>
					<div 
						style={{
							display: "flex",
							alignItems: "flex-start",
							background: "#FFFFFF",
							borderRadius: 12,
							paddingLeft: 20,
							paddingRight: 20,
							marginLeft: 267,
							boxShadow: "0px 1px 3px #00000003",
						}}>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 29,
								marginRight: 23,
							}}>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 20,
									marginLeft: 81,
								}}>
								<span 
									style={{
										color: "#979797",
										fontSize: 16,
										fontWeight: "bold",
										marginRight: 92,
									}} >
									{"All Chats"}
								</span>
								<span 
									style={{
										color: "#000000",
										fontSize: 16,
										fontWeight: "bold",
									}} >
									{"Groups"}
								</span>
							</div>
							<div 
								style={{
									alignSelf: "stretch",
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-end",
								}}>
								<div 
									style={{
										width: 74,
										height: 3,
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderTopLeftRadius: 8,
										borderTopRightRadius: 9,
										marginRight: 57,
									}}>
								</div>
							</div>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 27,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									background: "#FAFAFA",
									borderRadius: 8,
									border: `1px solid #E6E6E6`,
									paddingTop: 12,
									paddingBottom: 12,
									paddingLeft: 16,
									paddingRight: 225,
									marginBottom: 24,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/n55iyolu_expires_30_days.png"} 
									style={{
										width: 21,
										height: 21,
										objectFit: "fill",
									}}
								/>
								<input
									placeholder={"Search chat..."}
									value={input3}
									onChange={(event)=>onChangeInput3(event.target.value)}
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										width: 88,
										background: "none",
										border: "none",
										paddingTop: 2,
										paddingBottom: 2,
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/1oblbzm6_expires_30_days.png"} 
									style={{
										width: 54,
										height: 54,
										marginRight: 16,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										marginTop: 7,
										marginRight: 49,
										gap: 6,
									}}>
									<span 
										style={{
											color: "#010101",
											fontSize: 16,
											fontWeight: "bold",
										}} >
										{"Startup Strategy Hub"}
									</span>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
										}} >
										{"Created On: March 1, 2025 • 8 Learners"}
									</span>
								</div>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ts8v7seg_expires_30_days.png"} 
									style={{
										width: 19,
										height: 19,
										marginTop: 30,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 13,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/xgg6orjl_expires_30_days.png"} 
									style={{
										width: 54,
										height: 54,
										marginRight: 16,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										marginTop: 7,
										marginRight: 11,
										gap: 6,
									}}>
									<span 
										style={{
											color: "#010101",
											fontSize: 16,
											fontWeight: "bold",
										}} >
										{"Others Group"}
									</span>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
										}} >
										{"Created On: March 1, 2025 • 8 Learners"}
									</span>
								</div>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 12,
										marginTop: 10,
									}} >
									{"Yesterday"}
								</span>
							</div>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
								}}>
							</div>
						</div>
						<div 
							style={{
								width: 1,
								height: 1063,
								background: "#E6E6E6",
								marginRight: 24,
							}}>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 20,
								marginRight: 24,
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 15,
								}} >
								{"Upcoming Sessions"}
							</span>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 17,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									background: "#E6F7FD",
									borderRadius: 8,
									paddingTop: 8,
									paddingBottom: 8,
									paddingLeft: 12,
									paddingRight: 12,
									marginBottom: 24,
									gap: 12,
								}}>
								<button 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderRadius: 6,
										border: "none",
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 39,
										paddingRight: 39,
										textAlign: "left",
									}}
									onClick={()=>alert("Pressed!")}>
									<span 
										style={{
											color: "#FFFFFF",
											fontSize: 14,
											fontWeight: "bold",
										}} >
										{"With Mentor"}
									</span>
								</button>
								<button 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 6,
										border: "none",
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 29,
										paddingRight: 29,
										textAlign: "left",
									}}
									onClick={()=>alert("Pressed!")}>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 14,
											fontWeight: "bold",
										}} >
										{"Group Sessions"}
									</span>
								</button>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									paddingTop: 16,
									paddingBottom: 16,
									marginBottom: 20,
									boxShadow: "0px 1px 2px #00000008",
								}}>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginBottom: 10,
										marginLeft: 16,
										marginRight: 16,
									}}>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
											fontWeight: "bold",
											marginRight: 212,
										}} >
										{"Date & Time"}
									</span>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Duration"}
									</span>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginBottom: 20,
										marginLeft: 16,
										marginRight: 16,
									}}>
									<span 
										style={{
											color: "#010101",
											fontSize: 14,
											fontWeight: "bold",
											marginRight: 103,
										}} >
										{"11 April 2025, 15:00-16:00"}
									</span>
									<span 
										style={{
											color: "#010101",
											fontSize: 14,
											fontWeight: "bold",
										}} >
										{"30 mins"}
									</span>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginBottom: 10,
										marginLeft: 16,
										marginRight: 16,
									}}>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
											fontWeight: "bold",
											marginRight: 241,
										}} >
										{"Mentor"}
									</span>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Platform"}
									</span>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										marginBottom: 15,
										marginLeft: 16,
										marginRight: 16,
									}}>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											alignItems: "center",
											paddingRight: 3,
											gap: 6,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/y4it20rx_expires_30_days.png"} 
											style={{
												width: 19,
												height: 19,
												objectFit: "fill",
											}}
										/>
										<span 
											style={{
												color: "#010101",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"Jenny Wilson"}
										</span>
									</div>
									<div 
										style={{
											width: 115,
											alignSelf: "stretch",
										}}>
									</div>
									<span 
										style={{
											color: "#010101",
											fontSize: 14,
											fontWeight: "bold",
										}} >
										{"Zoom"}
									</span>
								</div>
								<button 
									style={{
										display: "flex",
										alignItems: "center",
										background: "#E6F7FD",
										borderRadius: 6,
										border: "none",
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 118,
										paddingRight: 118,
										marginLeft: 16,
										marginRight: 16,
										gap: 8,
										textAlign: "left",
									}}
									onClick={()=>alert("Pressed!")}>
									<span 
										style={{
											color: "#6BD0F6",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"View Details"}
									</span>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/cvgu9ssj_expires_30_days.png"} 
										style={{
											width: 15,
											height: 15,
											objectFit: "fill",
										}}
									/>
								</button>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									paddingTop: 16,
									paddingBottom: 16,
									marginBottom: 20,
									boxShadow: "0px 1px 2px #00000008",
								}}>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginBottom: 10,
										marginLeft: 16,
										marginRight: 16,
									}}>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
											fontWeight: "bold",
											marginRight: 212,
										}} >
										{"Date & Time"}
									</span>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Duration"}
									</span>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginBottom: 20,
										marginLeft: 16,
										marginRight: 16,
									}}>
									<span 
										style={{
											color: "#010101",
											fontSize: 14,
											fontWeight: "bold",
											marginRight: 103,
										}} >
										{"11 April 2025, 15:00-16:00"}
									</span>
									<span 
										style={{
											color: "#010101",
											fontSize: 14,
											fontWeight: "bold",
										}} >
										{"30 mins"}
									</span>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginBottom: 10,
										marginLeft: 16,
										marginRight: 16,
									}}>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
											fontWeight: "bold",
											marginRight: 241,
										}} >
										{"Mentor"}
									</span>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Platform"}
									</span>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										marginBottom: 15,
										marginLeft: 16,
										marginRight: 16,
									}}>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											alignItems: "center",
											paddingRight: 3,
											gap: 6,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/qyxfuekm_expires_30_days.png"} 
											style={{
												width: 19,
												height: 19,
												objectFit: "fill",
											}}
										/>
										<span 
											style={{
												color: "#010101",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"Jenny Wilson"}
										</span>
									</div>
									<div 
										style={{
											width: 115,
											alignSelf: "stretch",
										}}>
									</div>
									<span 
										style={{
											color: "#010101",
											fontSize: 14,
											fontWeight: "bold",
										}} >
										{"Zoom"}
									</span>
								</div>
								<button 
									style={{
										display: "flex",
										alignItems: "center",
										background: "#E6F7FD",
										borderRadius: 6,
										border: "none",
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 118,
										paddingRight: 118,
										marginLeft: 16,
										marginRight: 16,
										gap: 8,
										textAlign: "left",
									}}
									onClick={()=>alert("Pressed!")}>
									<span 
										style={{
											color: "#6BD0F6",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"View Details"}
									</span>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/rbo3eit9_expires_30_days.png"} 
										style={{
											width: 15,
											height: 15,
											objectFit: "fill",
										}}
									/>
								</button>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									paddingTop: 16,
									paddingBottom: 16,
									boxShadow: "0px 1px 2px #00000008",
								}}>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginBottom: 10,
										marginLeft: 16,
										marginRight: 16,
									}}>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
											fontWeight: "bold",
											marginRight: 212,
										}} >
										{"Date & Time"}
									</span>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Duration"}
									</span>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginBottom: 20,
										marginLeft: 16,
										marginRight: 16,
									}}>
									<span 
										style={{
											color: "#010101",
											fontSize: 14,
											fontWeight: "bold",
											marginRight: 103,
										}} >
										{"11 April 2025, 15:00-16:00"}
									</span>
									<span 
										style={{
											color: "#010101",
											fontSize: 14,
											fontWeight: "bold",
										}} >
										{"30 mins"}
									</span>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginBottom: 10,
										marginLeft: 16,
										marginRight: 16,
									}}>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
											fontWeight: "bold",
											marginRight: 241,
										}} >
										{"Mentor"}
									</span>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Platform"}
									</span>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										marginBottom: 15,
										marginLeft: 16,
										marginRight: 16,
									}}>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											alignItems: "center",
											paddingRight: 3,
											gap: 6,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/9qw7l469_expires_30_days.png"} 
											style={{
												width: 19,
												height: 19,
												objectFit: "fill",
											}}
										/>
										<span 
											style={{
												color: "#010101",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"Jenny Wilson"}
										</span>
									</div>
									<div 
										style={{
											width: 115,
											alignSelf: "stretch",
										}}>
									</div>
									<span 
										style={{
											color: "#010101",
											fontSize: 14,
											fontWeight: "bold",
										}} >
										{"Zoom"}
									</span>
								</div>
								<button 
									style={{
										display: "flex",
										alignItems: "center",
										background: "#E6F7FD",
										borderRadius: 6,
										border: "none",
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 118,
										paddingRight: 118,
										marginLeft: 16,
										marginRight: 16,
										gap: 8,
										textAlign: "left",
									}}
									onClick={()=>alert("Pressed!")}>
									<span 
										style={{
											color: "#6BD0F6",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"View Details"}
									</span>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/v4x193eq_expires_30_days.png"} 
										style={{
											width: 15,
											height: 15,
											objectFit: "fill",
										}}
									/>
								</button>
							</div>
						</div>
						<div 
							style={{
								width: 1,
								height: 1063,
								background: "#E6E6E6",
								marginRight: 23,
							}}>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 20,
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 15,
								}} >
								{"Session Details"}
							</span>
							<div 
								style={{
									width: 277,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 17,
								}}>
							</div>
							<span 
								style={{
									color: "#010101",
									fontSize: 20,
									fontWeight: "bold",
									marginBottom: 20,
								}} >
								{"Session Info"}
							</span>
							<span 
								style={{
									color: "#6C6C6C",
									fontSize: 14,
									marginBottom: 12,
								}} >
								{"Date & Time"}
							</span>
							<span 
								style={{
									color: "#010101",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 24,
								}} >
								{"11 April 2025, 15:00-16:00"}
							</span>
							<span 
								style={{
									color: "#6C6C6C",
									fontSize: 14,
									marginBottom: 12,
								}} >
								{"Duration"}
							</span>
							<span 
								style={{
									color: "#010101",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 24,
								}} >
								{"30 mins"}
							</span>
							<span 
								style={{
									color: "#6C6C6C",
									fontSize: 14,
									marginBottom: 12,
								}} >
								{"Platform"}
							</span>
							<span 
								style={{
									color: "#010101",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 24,
								}} >
								{"Zoom meeting"}
							</span>
							<span 
								style={{
									color: "#6C6C6C",
									fontSize: 14,
									marginBottom: 12,
								}} >
								{"Meeting Link"}
							</span>
							<span 
								style={{
									color: "#1074BC",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 32,
								}} >
								{"https://zoom.us/johndoe/meeting"}
							</span>
							<div 
								style={{
									width: 277,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 31,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									marginBottom: 32,
									gap: 20,
								}}>
								<span 
									style={{
										color: "#010101",
										fontSize: 20,
										fontWeight: "bold",
									}} >
									{"Reminder"}
								</span>
								<div 
									style={{
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#E6F7FD",
										borderRadius: 12,
										paddingTop: 20,
										paddingBottom: 20,
										gap: 12,
									}}>
									<span 
										style={{
											color: "#010101",
											fontSize: 16,
											fontWeight: "bold",
											marginLeft: 12,
										}} >
										{"11 April 2025, 15:00-16:00"}
									</span>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											marginLeft: 12,
											marginRight: 12,
										}}>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 14,
												fontWeight: "bold",
												marginRight: 98,
											}} >
											{"Meeting purpose"}
										</span>
										<div 
											style={{
												flexShrink: 0,
												alignItems: "flex-start",
												background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
												borderRadius: 64,
												paddingBottom: 3,
												paddingLeft: 19,
												paddingRight: 2,
											}}>
											<div 
												style={{
													width: 17,
													height: 17,
													background: "#FFFFFF",
													borderRadius: 64,
													boxShadow: "0px 1.9354838132858276px 0px #0000000D",
												}}>
											</div>
										</div>
									</div>
								</div>
							</div>
							<span 
								style={{
									color: "#010101",
									fontSize: 20,
									fontWeight: "bold",
									marginBottom: 12,
								}} >
								{"Mentor Info"}
							</span>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "center",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									paddingTop: 18,
									paddingBottom: 18,
									paddingLeft: 15,
									paddingRight: 15,
									marginBottom: 20,
									gap: 14,
									boxShadow: "0px 1px 2px #00000008",
								}}>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										paddingRight: 1,
										gap: 12,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/9ivcvew9_expires_30_days.png"} 
										style={{
											width: 55,
											height: 55,
											objectFit: "fill",
										}}
									/>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 4,
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 16,
												fontWeight: "bold",
											}} >
											{"Jenny Wilson"}
										</span>
										<span 
											style={{
												color: "#00AEEF",
												fontSize: 10,
												fontWeight: "bold",
											}} >
											{"Senior Teacher at Harvard University"}
										</span>
										<div 
											style={{
												display: "flex",
												alignItems: "flex-start",
												paddingRight: 1,
												gap: 8,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/kwnx4ntw_expires_30_days.png"} 
												style={{
													width: 12,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"New York City, USA"}
											</span>
										</div>
									</div>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										background: "#E6F7FD",
										borderRadius: 8,
										paddingTop: 10,
										paddingBottom: 10,
										paddingLeft: 70,
										paddingRight: 71,
										gap: 6,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/bsiimy26_expires_30_days.png"} 
										style={{
											width: 15,
											height: 15,
											objectFit: "fill",
										}}
									/>
									<span 
										style={{
											color: "#00AEEF",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Send Message"}
									</span>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									background: "#F1F2F4",
									borderRadius: 8,
									paddingTop: 16,
									paddingBottom: 16,
									paddingLeft: 76,
									paddingRight: 78,
									marginBottom: 12,
									gap: 4,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/jjjfrldl_expires_30_days.png"} 
									style={{
										width: 17,
										height: 17,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										fontWeight: "bold",
									}} >
									{"Cancel Session"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
									borderRadius: 8,
									paddingTop: 16,
									paddingBottom: 16,
									paddingLeft: 73,
									paddingRight: 75,
									gap: 4,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/dnjkz34f_expires_30_days.png"} 
									style={{
										width: 17,
										height: 17,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#FFFFFF",
										fontSize: 14,
										fontWeight: "bold",
									}} >
									{"Notify to Mentor"}
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}